<template>
  <div>
    <!-- 操作按钮区域 -->
    <div class="table-page-search-wrapper" style="margin-bottom: 20px;">
      <a-row :gutter="24">
        <a-col :md="12" :sm="12">
          <a-upload
            name="file"
            :showUploadList="false"
            :multiple="false"
            :headers="tokenHeader"
            :action="importExcelUrl"
            @change="handleImportExcel"
            :beforeUpload="beforeUpload">
            <a-button type="primary" icon="upload">选择文件导入</a-button>
          </a-upload>
        </a-col>
        <a-col :md="12" :sm="12">
          <a :href="`${path}业绩递交模板_02.11.xls`" download="业绩递交模板.xls" style="margin-left: 10px;">
            <a-button type="link" icon="download">模板下载</a-button>
          </a>
        </a-col>
      </a-row>
      <a-row style="margin-top: 10px;">
        <a-col>
          <span style="color: #999;">支持 .xls/.xlsx 格式，上传Excel后系统将根据保单号+保险公司+期数+项目+部门查询匹配的已确认业绩</span>
        </a-col>
      </a-row>
    </div>

    <!-- 导入说明 -->
    <a-alert type="info" style="margin-top: 20px; padding: 8px 16px;">
      <span slot="message" style="font-size: 12px;">
        <strong>导入开票流程：</strong>
        1. 上传Excel → 2. 系统匹配业绩 → 3. 勾选已确认业绩 → 4. 添加到开票列表 → 5. 推送发票
      </span>
    </a-alert>

    <!-- 匹配结果表格 -->
    <div v-if="importDataSource.length > 0" style="margin-top: 20px;">
      <div class="table-operator" style="margin-bottom: 10px;">
        <a-button type="primary" icon="plus" @click="handleAddToInvoiceList" :disabled="selectedRowKeys.length === 0">
          添加到开票列表 ({{ selectedRowKeys.length }})
        </a-button>
        <a-button icon="reload" @click="handleClearList" style="margin-left: 8px;">
          重新导入
        </a-button>
      </div>

      <div class="ant-alert ant-alert-info" style="margin-bottom: 10px;height: 40px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 共导入 <a style="font-weight: 600">{{ importDataSource.length }}</a> 条Excel数据，匹配到 <a style="font-weight: 600">{{ matchedCount }}</a> 条业绩，已确认 <a style="font-weight: 600">{{ confirmedCount }}</a> 条
        <a style="margin-left: 24px" @click="onClearSelected">清空选择</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: 3200, y: 700 }"
        bordered
        :rowKey="(record) => record.id || record.excelPolicy"
        :columns="columns"
        :dataSource="importDataSource"
        :pagination="false"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :rowClassName="getRowClassName">
        
        <template slot="statusSlot" slot-scope="text, record">
          <a-tag v-if="text=='0'" color="red">未提交</a-tag>
          <a-tag v-else-if="text=='1'" color="green">已确认</a-tag>
          <a-tag v-else-if="text=='2'" color="orange">已退回</a-tag>
          <a-tag v-else-if="text=='3'" color="blue">已匹配</a-tag>
          <a-tag v-else-if="text=='4'" color="purple">已提交</a-tag>
          <span v-else-if="record.matched === false" style="color: red;">{{ record.message }}</span>
        </template>

        <template slot="colorSlot" slot-scope="text">
          <span>{{ !text ? '': Number(text).toLocaleString() }}</span>
        </template>
      </a-table>
    </div>

    <!-- 空状态 -->
    <div v-if="importDataSource.length === 0 && !loading" style="text-align: center; padding: 80px 0; color: #999;">
      <a-icon type="inbox" style="font-size: 64px; color: #ddd;" />
      <p style="margin-top: 16px; font-size: 16px;">请上传业绩Excel文件进行开票</p>
      <p style="margin-top: 8px; font-size: 14px; color: #999;">
        系统将根据Excel中的保单号+保险公司+期数+项目+部门查询匹配的业绩
      </p>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { getAction, postAction } from '@/api/manage'
  import { mapActions } from 'vuex'

  const ACCESS_TOKEN = 'Access-Token'
  
  export default {
    name: 'BizDirectInvoiceImport',
    data() {
      return {
        description: '业务人员直接开票 - 导入开票',
        loading: false,
        importDataSource: [],
        selectedRowKeys: [],
        selectionRows: [],
        path: 'https://ja-001.oss-cn-qingdao.aliyuncs.com/project/bms/template/',
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            fixed: 'left',
            align: "center",
            customRender: function(t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '业绩编号',
            className: 'column-text',
            align: "center",
            width: 200,
            fixed: 'left',
            dataIndex: 'businessNumber'
          },
          {
            title: '业绩状态',
            align: "center",
            width: 100,
            dataIndex: 'status',
            scopedSlots: { customRender: 'statusSlot' }
          },
          {
            title: '业务类型',
            className: 'column-text',
            align: "center",
            width: 100,
            dataIndex: 'businessType_dictText'
          },
          {
            title: '标的类型',
            className: 'column-text',
            align: "center",
            width: 100,
            dataIndex: 'productOrLife_dictText'
          },
          {
            title: '项目',
            className: 'column-text',
            align: "center",
            width: 280,
            dataIndex: 'project_dictText'
          },
          {
            title: '二级单位',
            className: 'column-text',
            align: "center",
            width: 180,
            dataIndex: 'insureParentOrg_dictText'
          },
          {
            title: '部门',
            className: 'column-text',
            align: "center",
            width: 100,
            dataIndex: 'sysOrgCode_dictText'
          },
          {
            title: '经纪人',
            className: 'column-text',
            align: "center",
            width: 100,
            dataIndex: 'createBy_dictText'
          },
          {
            title: '投保人',
            className: 'column-text',
            align: "center",
            width: 350,
            dataIndex: 'insure'
          },
          {
            title: '被保险人',
            className: 'column-text',
            align: "center",
            width: 350,
            dataIndex: 'insured'
          },
          {
            title: '保险人',
            className: 'column-text',
            align: "center",
            width: 350,
            dataIndex: 'insurerNumber_dictText'
          },
          {
            title: '险种类型',
            className: 'column-text',
            align: "center",
            width: 270,
            dataIndex: 'insuranceType_dictText'
          },
          {
            title: '险种名称',
            className: 'column-text',
            align: "center",
            width: 180,
            dataIndex: 'insuranceName'
          },
          {
            title: '车牌号',
            className: 'column-text',
            align: "center",
            width: 100,
            dataIndex: 'car'
          },
          {
            title: '保险起期',
            align: "center",
            width: 120,
            dataIndex: 'insuranceStart',
            customRender: function(text) {
              return !text ? '' : (text.length > 10 ? text.substr(0, 10) : text)
            }
          },
          {
            title: '保险讫期',
            align: "center",
            width: 120,
            dataIndex: 'insuranceEnd',
            customRender: function(text) {
              return !text ? '' : (text.length > 10 ? text.substr(0, 10) : text)
            }
          },
          {
            title: '保额',
            align: "center",
            width: 100,
            dataIndex: 'insuredAmount',
            className: 'column-money',
            customRender: function(text) {
              return !text ? '' : text.toLocaleString()
            }
          },
          {
            title: '费率',
            align: "center",
            width: 100,
            dataIndex: 'rate',
            customRender: function(text) {
              return !text ? '' : text + '%'
            }
          },
          {
            title: '保费',
            align: "center",
            width: 100,
            dataIndex: 'premium',
            className: 'column-money',
            customRender: function(text) {
              return !text ? '' : text.toLocaleString()
            }
          },
          {
            title: '净佣金',
            align: "center",
            width: 100,
            dataIndex: 'cleanPremium',
            className: 'column-money',
            customRender: function(text) {
              return !text ? '' : text.toLocaleString()
            }
          },
          {
            title: '是否含税',
            align: "center",
            width: 90,
            dataIndex: 'includeTax_dictText'
          },
          {
            title: '佣金比例',
            align: "center",
            width: 100,
            dataIndex: 'brokerageRatio',
            customRender: function(text) {
              return !text ? '' : text + '%'
            }
          },
          {
            title: '总佣金',
            align: "center",
            width: 100,
            dataIndex: 'brokerageTotal',
            className: 'column-money',
            scopedSlots: { customRender: 'colorSlot' }
          },
          {
            title: '期数',
            align: "center",
            width: 80,
            dataIndex: 'phase'
          },
          {
            title: '导入时间',
            align: "center",
            width: 120,
            dataIndex: 'createTime',
            customRender: function(text) {
              return !text ? '' : (text.length > 10 ? text.substr(0, 10) : text)
            }
          },
          {
            title: '确认时间',
            align: "center",
            width: 120,
            dataIndex: 'confirmTime',
            customRender: function(text) {
              return !text ? '' : (text.length > 10 ? text.substr(0, 10) : text)
            }
          }
        ],
        url: {
          queryByImportData: "bms/bizBusinessinfo/queryByImportData"
        }
      }
    },
    computed: {
      tokenHeader() {
        return {
          'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)
        }
      },
      importExcelUrl() {
        return `${window._CONFIG['domianURL']}/${this.url.queryByImportData}`
      },
      matchedCount() {
        return this.importDataSource.filter(item => item.matched === true).length
      },
      confirmedCount() {
        return this.importDataSource.filter(item => item.status === '1').length
      }
    },
    methods: {
      ...mapActions('invoice', ['addToInvoiceList']),
      beforeUpload(file) {
        this.loading = true
        return true
      },
      handleImportExcel(info) {
        if (info.file.status !== 'uploading') {
          console.log(info.file, info.fileList)
        }
        if (info.file.status === 'done') {
          this.loading = false
          if (info.file.response.success) {
            this.importDataSource = info.file.response.result || []
            this.$message.success(`导入成功，共 ${this.importDataSource.length} 条Excel数据，匹配到 ${this.matchedCount} 条业绩，其中 ${this.confirmedCount} 条已确认`)
          } else {
            this.$message.error(info.file.response.message || '查询失败')
          }
        } else if (info.file.status === 'error') {
          this.loading = false
          this.$message.error(`文件上传失败`)
        }
      },
      onSelectChange(selectedRowKeys, selectionRows) {
        // 只允许选择已确认状态的记录
        const confirmedRows = selectionRows.filter(row => row.status === '1' && row.matched !== false)
        this.selectedRowKeys = confirmedRows.map(row => row.id)
        this.selectionRows = confirmedRows
      },
      onClearSelected() {
        this.selectedRowKeys = []
        this.selectionRows = []
      },
      getRowClassName(record) {
        // 非已确认状态或未匹配的记录禁用
        if (record.matched === false || record.status !== '1') {
          return 'row-disabled'
        }
        return ''
      },
      handleAddToInvoiceList() {
        if (this.selectionRows.length === 0) {
          this.$message.warning('请先选择要添加的业绩（已确认状态）')
          return
        }
        this.addToInvoiceList(this.selectionRows)
        this.$message.success(`已添加 ${this.selectionRows.length} 条业绩到开票列表`)
        this.onClearSelected()
      },
      handleClearList() {
        this.importDataSource = []
        this.selectedRowKeys = []
        this.selectionRows = []
      }
    }
  }
</script>

<style scoped>
</style>
